module.exports = __webpack_public_path__ + "img/error_500_sp.12f8ae53.svg";